// extracted by css-extract-rspack-plugin
export default {"categoryCardImage":"CategoryCard-module__categoryCardImage__XxjFdZY","categoryCard":"CategoryCard-module__categoryCard__yR64y4C"};